<template>
<v-app>

  <v-app-bar color="#FF9800" dark :fixed="true">
    <v-toolbar-title>
      <router-link to="/uzenofal">
        <a class="brand-logo">
          <img v-if="prod == 'true'" src="./assets/logo_2025_web.png" width="70">
          <img v-if="prod == 'false'" src="./assets/dev_logo.png" width="62">
        </a>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

<div class="hidden-sm-and-down">
  <v-btn text to="/diakok">Diákok<v-icon right>account_circle</v-icon></v-btn>
  <v-btn text to="/tanfolyamok">Tanfolyamok<v-icon right>school</v-icon></v-btn>
  <v-btn text to="/orarend">Órarend<v-icon right>alarm</v-icon></v-btn>
  <v-btn text to="/vizsgak">Vizsgák<v-icon right>date_range</v-icon></v-btn>
  <v-btn text to="/oktatok">Oktatók<v-icon right>drive_eta</v-icon></v-btn>
  <v-btn text to="/orvosi">Orvosi<v-icon right>medical_services</v-icon></v-btn>
  <v-btn icon to="/setup"><v-icon >settings</v-icon></v-btn>
  <v-btn icon to="/login"><v-icon >power_settings_new</v-icon></v-btn>
</div>

<div class="hidden-md-and-up">
<v-menu>
  <template v-slot:activator="{ on }">
    <v-btn icon v-on="on">
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
  </template>

  <v-list>
    <v-list-item to="/diakok" color="#FF9800">
      <v-list-item-title>Diákok<v-icon right>account_circle</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/tanfolyamok" color="#FF9800">
      <v-list-item-title>Tanfolyamok<v-icon right>school</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/orarend" color="#FF9800">
      <v-list-item-title>Órarend<v-icon right>alarm</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/vizsgak" color="#FF9800">
      <v-list-item-title>Vizsgák<v-icon right>date_range</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/oktatok" color="#FF9800">
      <v-list-item-title>Oktatók<v-icon right>drive_eta</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/orvosi" color="#FF9800">
      <v-list-item-title>Orvosi<v-icon right>medical_services</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/setup" color="#FF9800">
      <v-list-item-title>Beállítások<v-icon right>settings</v-icon></v-list-item-title>
    </v-list-item>
    <v-list-item to="/login" color="#FF9800">
      <v-list-item-title>Belépés<v-icon right>power_settings_new</v-icon></v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>
</div>

    <v-progress-linear :active="preloader" :indeterminate="preloader" absolute bottom color="teal"></v-progress-linear>
  </v-app-bar>

  <div class="mb-12"></div>
  <div class="mb-6"></div>

      <keep-alive>
        <router-view></router-view>
      </keep-alive>

</v-app>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth';
import store from './store'
import { mapFields } from 'vuex-map-fields'

export default {
  data () {
    return {
    }
  },
  methods: {
    getUserInfo: async function() {
      await this.userState()
      await this.gettoken()
      this.$http.post('/user', {
        token: this.token,
        fbuser: this.fbuser,
      }).then((response) => {
        this.admin = response.data['admin']
        this.loginuser = response.data['loginuser']
        this.username = response.data['name']
        this.placeid = response.data['placeid']

      }, (error) => {
        this.error_text = error.data
      })
    },
    userState: function () {
      var user = firebase.auth().currentUser;
      if (user) {
        this.fbuser = user.email;
      } else {
        console.log("No user is signed in.");
        this.fbuser = null;
      }
    },
    getConfig: async function() {
      this.exams = ''
      await this.gettoken()
      this.$http.post('/get_config', {
        token: this.token
      }).then((response) => {
        this.prod = response.data['db']
        this.host = response.data['host']

      }, (error) => {
        this.error_text = error.data
      })
    },
  },
  mounted() {
    this.getUserInfo()
    this.getConfig()
  },
  computed: {
  ...mapFields([
  'showing.preloader',
  'auth.admin',
  'auth.fbuser',
  'auth.loginuser',
  'auth.username',
  'auth.placeid',
  'auth.prod',
]),
}
}
</script>

<style lang="scss">
/*
@import "@material/textfield/mdc-text-field";
@import "@material/line-ripple/mdc-line-ripple";
@import "@material/floating-label/mdc-floating-label";
@import "@material/notched-outline/mdc-notched-outline";
*/

.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.table-enter-active {
  transition: opacity 1.5s;
}
.table-leave-active {
  opacity: 0;
}
.table-enter,
.table-leave-to {
  opacity: 0;
}
</style>
